<div class="d-flex flex-fill justify-content-center flex-row">
    <div class="d-flex flex-column justify-content-center">
        <p class="text-center">
            Our application does not support mobile phones yet
        </p>
        <p class="text-center">
            Please view this screen on a desktop computer
        </p>
    </div>
</div>